import React, { useMemo } from 'react';
import ListTable from "src/pages/callrecorder/PhoneNumberPriceHistories/_partials/_ListTable";

const _PriceHistories = ({ csvImportId, processedRows }: { csvImportId: string | undefined, processedRows?: number }) => {
  const filterParams = useMemo(() => ({ csv_import_id: csvImportId }), [csvImportId, processedRows]);

  if (!csvImportId) return null;

  return <ListTable filterParams={filterParams} />;
}

export default _PriceHistories;
